export default __webpack_public_path__ + "static/media/cover.84489ddf.png";